export default "__VITE_ASSET__CzN7caUb__"